<div #colorways>
    <div *ngIf="products.length > 1"
        class="swatch-wrapper align-items-center d-flex flex-row gap-3 overflow-x-scroll overflow-y-visible ps-2 py-3">
        @for (product of products; track $index) {
        @for (metafield of product.metafields; track $index) {
        @if (metafield?.key == 'swatch_colors') {
        <a (hover)="preLoadImage(product)" (pointerover)="preLoadImage(product)"
            ((pointerenter))="preLoadImage(product)" (click)="emitProduct(product)" role="button"
            [attr.aria-label]="product.title | colorWithoutTitle" class="swatch rounded-5"
            [ngClass]="{'selected': product.handle == parentProduct.handle}">
            <div class="color-swatch w-100 h-100 rounded-5" [style]="{background: turnIntoGradient(metafield.value)}"
                [ngClass]="{'selected': product.handle == parentProduct.handle}">
            </div>
        </a>
        }
        }
        }
    </div>
</div>